import { defineStore } from "pinia";
import { ref } from "vue";

type UiStateType = "idle" | "loading";

export const useUiStateStore = defineStore("uiState", () => {
    const uiState = ref<UiStateType>("idle");

    const setUiState = (newState: UiStateType) => {
        uiState.value = newState;
    };

    return { uiState, setUiState };
});
